import { Component, OnInit } from '@angular/core';
//import { FormGroup, FormControl } from "@angular/forms";
import { Title } from '@angular/platform-browser';
import { MuestraService } from "../../../modulo-comunes/servicios/muestra-servicios";
import { LogService } from "../../../modulo-comunes/servicios/log-servicios";
import { DataEmpresaService } from '../../../modulo-comunes/servicios/data-empresa-servicios';

@Component({
  selector: 'app-terminosuso',
  templateUrl: './terminos-uso.component.html',
  styleUrls: ['./terminos-uso.component.css']
})
export class TerminosUsoComponent implements OnInit {
  sitio: string = 'EasyMed';
  funciones: string = '';
  usuarios: string = '';
  proveedor: string = '';
  tecnica: string = '';
  licencia: string = '';
  privacidad: string = '';
  privacidadSalud: string = '';
  responsabilidad: string = '';
  comerciales: string = '';

  constructor(
    private titleService: Title,
    private muestraService: MuestraService,
    private logService: LogService,
    public dataEmpresaService: DataEmpresaService
  ) {
    this.sitio = this.dataEmpresaService.sitioElegido;
  }

  ngOnInit() {
    this.titleService.setTitle(this.sitio);

    if (this.sitio == 'EasyMed') {
      this.funciones =
        'EASYMED es un SISTEMA destinado a almacenar la información de un CONSULTORIO MEDICO, que de aquí en adelante ' +
        'llamaremos el Consultorio o la Empresa Usuaria. Cada Consultorio que utilice el sistema nombrará un ' +
        'ADMINISTRADOR que aprobará las personas que pueden ingresar a EasyMed (los USUARIOS). Los Usuarios ' +
        'podrán ser uno o varios, y entre ellos podrán estar Médicos, asistentes y personal administrativo. ' +
        'El Administrador asignará PERMISOS a los Usuarios para realizar ciertas FUNCIONES.<br><br>' +
        'Por la naturaleza del Sistema, los Usuarios ingresarán, de acuerdo a las funciones que se les hayan ' +
        'asignado, datos de los PACIENTES que visitan el Consultorio, como información personal, antecedentes y ' +
        'datos de la historia clínica, incluyendo la información tomada por el Médico durante cada consulta ' +
        'a la que asista el Paciente.<br><br>' +
        'En EasyMed se ingresarán también datos de uso administrativo, como los horarios de las citas médicas, los ' +
        'costos de las consultas y las facturas electrónicas emitidas a los Pacientes.<br>'
    } else {
      this.funciones =
        'EFISYS FACTURACION es un SISTEMA destinado a facilitar la emisión de facturas electrónicas a personas, oficinas o ' +
        'empresas de pequeño tamaño, a quienes de aquí en adelante llamaremos EMPRESAS o EMPRESAS USUARIAS. Cada Empresa ' +
        'nombrará un ADMINISTRADOR que aprobará las personas que pueden ingresar a Efisys (los USUARIOS). ' +
        'El Administrador asignará PERMISOS a los Usuarios para realizar ciertas FUNCIONES.<br><br>' +
        'Por la naturaleza del Sistema, los Usuarios ingresarán, de acuerdo a las funciones que se les hayan ' +
        'asignado, datos personales de los CLIENTES, datos de los ARTICULOS que vende la Empresa, ya sean productos ' +
        'o servicios, y las FACTURAS ELECTRONICAS emitidas a los Clientes.<br>'
    }

    this.proveedor =
      'El proveedor del sistema ' + this.sitio + ' es SMARTTEC CIA. LTDA., empresa domiciliada en Quito, Ecuador, ' +
      'con la que puede contactarse utilizando los canales presentados al final de esta página. Smarttec utiliza ' +
      'herramientas y servicios de terceros, pero solo Smarttec está en capacidad y responsabilidad de atender ' +
      'preguntas o problemas relacionados al sistema.<br><br>' +
      'Smarttec es la titular de los derechos de propiedad intelectual del sistema ' + this.sitio + '.<br>'

    if (this.sitio == 'EasyMed') {
      this.usuarios =
        'El Consultorio Médico solicitará por medio de su representante legal la creación de una base de datos del ' +
        'sistema EasyMed. Smarttec aprobará la creación de la base de datos.<br><br>' +
        'El Consultorio Médico definirá los procedimientos internos para la creación y autorización de Usuarios, nombrará ' +
        'a uno de sus Usuarios como Administrador y lo informará a Smarttec para que lo configure como tal.<br><br>' +
        'Los integrantes del Consultorio Médico crearán sus propias claves del sistema y luego solicitarán acceso a ' +
        'la base de datos. El Administrador deberá conceder el acceso solo a las personas autorizadas, lo que los ' +
        'convierte en Usuarios del sistema.<br><br>' +
        'Las personas ajenas al Consultorio tienen prohibido solicitar acceso al mismo. Si el Administrador detecta ' +
        'estos casos deberá negar el acceso y de ser necesario, informar a las autoridades.<br><br>' +
        'Todos los participantes mencionados, al momento de solicitar la creación de la base de datos, crear sus claves, ' +
        'solicitar acceso y utilizar el sistema, aceptan los términos y condiciones de uso del sistema EasyMed.<br>'
    } else {
      this.usuarios =
        'La Empresa Usuaria solicitará por medio de su representante legal la creación de una base de datos del ' +
        'sistema Efisys. Smarttec aprobará la creación de la base de datos.<br><br>' +
        'La Empresa Usuaria definirá los procedimientos internos para la creación y autorización de Usuarios, nombrará ' +
        'a uno de sus Usuarios como Administrador y lo informará a Smarttec para que lo configure como tal.<br><br>' +
        'Los integrantes de la Empresa Usuaria crearán sus propias claves del sistema y luego solicitarán acceso a ' +
        'la base de datos. El Administrador deberá conceder el acceso solo a las personas autorizadas, lo que los ' +
        'convierte en Usuarios del sistema.<br><br>' +
        'Las personas ajenas a la Empresa Usuaria tienen prohibido solicitar acceso a ésta. Si el Administrador detecta ' +
        'estos casos deberá negar el acceso y de ser necesario, informar a las autoridades.<br><br>' +
        'Todos los participantes mencionados, al momento de solicitar la creación de la base de datos, crear sus claves, ' +
        'solicitar acceso y utilizar el sistema, aceptan los términos y condiciones de uso del sistema Efisys.<br>'
    }

    this.tecnica =
      'El sistema ' + this.sitio + ' tiene su base de datos y sus programas en servidores de terceros accesibles ' +
      'a los Usuarios en Internet por medio de programas navegadores como Google Chrome, ' +
      'Mozilla Firefox o Microsoft Edge, en versiones actualizadas (creadas mínimo desde el año 2020).<br><br>' +
      'Debido a esta configuración, es indispensable que los Usuarios cuenten con un servicio de Internet rápido ' +
      'y estable para poder utilizar  ' + this.sitio + ' de forma adecuada. La calidad y disponibilidad del servicio ' +
      'de Internet son responsabilidad del respectivo proveedor y los Usuarios deberán consultar directamente con ' +
      'dicho proveedor en caso de problemas con ese servicio.<br><br>' +
      'Del mismo modo, cada Usuario deberá contar con un computador actualizado, bien configurado, con los recursos ' +
      'suficientes y las protecciones necesarias. Cualquier problema con los computadores, energía eléctrica, redes ' +
      'de datos, virus, etc., deben ser gestionados por el Usuario con sus proveedores de servicio técnico.<br>'

    this.licencia =
      'Smarttec concede a la Empresa Usuaria una licencia de uso no exclusiva del sistema ' + this.sitio + ' mientras ' +
      'ésta se mantenga al día en el cumplimiento de las condiciones comerciales establecidas al momento de solicitar ' +
      'la creación de la base de datos o al solicitar cambios posteriores y que constan en la pantalla Mi Plan ' +
      'del menú Configuración.<br><br>' +
      'El sistema se ofrece como es, sin compromiso alguno de hacer modificaciones o adaptaciones. Smarttec evaluará ' +
      'todo pedido de desarrollo únicamente según su propio criterio y si decide aceptarlo, lo incluirá como parte ' +
      'de su plan de desarrollo del sistema, sin compromiso de plazo o especificaciones. El hecho de desarrollar ' +
      'un pedido no concede ningún derecho sobre la propiedad intelectual del sistema a quien lo pidió.<br><br>' +
      'La licencia de uso no concede a los Usuarios derechos sobre los diseños del sistema o de la base de datos, ' +
      'programas fuentes, técnicas de desarrollo, configuraciones, etc., ni siquiera el derecho a observar o auditar ' +
      'dichos diseños o la implementación real del sistema.<br><br>' +
      'Se considerarán violaciones graves a la licencia de uso ejecutar acciones o permitírselas a terceros, que ' +
      'tengan el resultado de afectar la propiedad intelectual de Smarttec sobre el sistema o la privacidad de los ' +
      'datos, tales como: obtener los programas fuentes del sistema, acceder a una base de datos por medio de ' +
      'herramientas ajenas al sistema, obtener acceso al sistema por medio de engaño o simulación, etc. ' +
      'Estas violaciones causarán la terminación inmediata de la licencia de uso sin perjuicio de otras acciones ' +
      'que Smarttec o las personas afectadas consideren pertinentes.<br><br>' +
      'Smarttec podrá, por su propio criterio, decidir la terminación de la licencia de uso del sistema. ' +
      'Para ello, notificará esta terminación a las Empresas Usuarias con anticipación mínima de 6 meses.<br>'

    this.privacidad =
      'Smarttec ha tomado todas las medidas técnicas a su alcance para asegurar que la información que se almacene ' +
      'en el sistema ' + this.sitio + ' no pueda ser observada ni modificada excepto por las personas autorizadas ' +
      'por la Empresa Usuaria y el personal de soporte técnico de Smarttec.<br><br>' +
      'Smarttec se compromete a no consultar ni observar los datos ingresados por las Empresas Usuarias del sistema, ' +
      'salvo en los casos en que deba hacerlo a pedido de los Usuarios para prestar soporte técnico si se ' +
      'presentara algún problema en el sistema, y en ese caso se compromete a no revelar a terceros la información ' +
      'que haya llegado a observar.<br><br>' +
      'Smarttec se compromete a no entregar a terceros ninguna información que se encuentre en el sistema, en ' +
      'particular, información de correos electrónicos, direcciones, teléfonos u otras que puedan ser usadas para ' +
      'campañas de correo o publicidad.<br><br>' +
      'Smarttec solo podrá extraer y presentar información contenida en la base de datos de ser ordenada por autoridades ' +
      'competentes.<br>'

    this.privacidadSalud =
      'De acuerdo a la Ley de Protección de Datos Personales vigente en Ecuador, el Consultorio Médico cumple roles de ' +
      'Responsable del Tratamiento de Datos Personales de sus Pacientes en cuanto decide la finalidad y uso de los datos ' +
      'personales obtenidos; los Médicos y otros Usuarios del Consultorio cumplen un papel de Encargados del Tratamiento ' +
      'de Datos Personales, en cuanto ingresan y consultan esos datos; y Smarttec actúa como Encargado del Tratamiento ' +
      'de Datos Personales en cuanto gestiona su almacenamiento. El Tratamiento de los Datos Personales consiste ' +
      'en el ingreso y consulta de información por parte de los Médicos y otros Usuarios del Consultorio y su ' +
      'almacenamiento, con el exclusivo fin de atender la salud de los Pacientes, conforme los parámetros establecidos ' +
      'en la mencionada Ley, la legislación especializada en la materia y los principios de confidencialidad y ' +
      'secreto profesional.<br><br>' +
      'El Responsable y el Encargado del Tratamiento de Datos Personales no utilizarán ni revelarán a terceros los datos ' +
      'personales con objetivos de mercadeo, publicidad, selección laboral, etc. <br><br>' +
      'Los Pacientes deben conocer que se van tomar datos personales y datos de salud y que se los va a conservar en una ' +
      'base de datos. Aunque el Art. 31 de la ley parece indicar que no es necesario el consentimiento escrito por parte ' +
      'de los Pacientes, recomendamos al Consultorio Médico hacerlo o, en caso de duda, solicitar el criterio de sus ' +
      'asesores legales.<br><br>' +
      'Smarttec utilizará todas las previsiones posibles para evitar el acceso no autorizado o ilícito, la pérdida, ' +
      'destrucción o daño accidental de la información.<br>'

    this.responsabilidad =
      'Al aceptar estos Términos y Condiciones de uso, tanto la Empresa Usuaria como los Usuarios acuerdan: <br><br>' +
      'Eximir de responsabilidad e incluso indemnizar a Smarttec, si fuera el caso, por cualquier demanda, pérdida, ' +
      'responsabilidad, indemnización, gasto, etc., derivado de reclamos de terceros por el uso, la imposibilidad de ' +
      'uso o relacionados con el uso del sistema ' + this.sitio + '.<br><br>' +
      'La Empresa Usuaria asume toda la responsabilidad por la información almacenada en el sistema, por los errores o ' +
      'inexactitudes de contenido, y por las consecuencias que puedan derivarse del uso de la información.<br><br>' +
      'En caso de problemas con el uso del sistema, la responsabilidad de Smarttec se limita a tomar las acciones ' +
      'que permitan recuperar la disponibilidad o resolver los problemas. En ningún caso, la Empresa Usuaria podrá ' +
      'demandar o reclamar a Smarttec daños, perjuicios o lucro cesante, por problemas ' +
      'derivados del uso, la imposibilidad de uso o relacionados con el uso del sistema.<br>'

    this.comerciales =
      'Las condiciones comerciales para el uso del sistema ' + this.sitio + ' se encuentran en la la pantalla Mi Plan ' +
      'del menú Configuración.<br>'
  }
}
